import React from 'react';
import './ExbabelLoading.css';

export function ExbabelLoading({ label = 'Loading', compact = false, inverted = false, fullScreen = false }) {
  const content = (
    <div
      className={`exbabel-loading ${inverted ? 'exbabel-loading-inverted' : ''}`}
      role="status"
      aria-label={label}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: compact ? '8px' : '12px',
        padding: compact ? '12px 0' : '24px 0',
      }}
    >
      <svg
        className={`exbabel-loading-mark ${inverted ? 'exbabel-mark-inverted' : ''}`}
        width={compact ? 36 : 52}
        height={compact ? 36 : 52}
        viewBox="0 0 64 64"
        aria-hidden="true"
      >
        <circle className="exbabel-loading-disc" cx="32" cy="32" r="30" />
        <path className="exbabel-loading-wave wave-one" d="M15 23 Q23.5 15 32 23 T49 23" />
        <path className="exbabel-loading-wave wave-two" d="M15 33 Q23.5 25 32 33 T49 33" />
        <path className="exbabel-loading-wave wave-three" d="M15 43 Q23.5 35 32 43 T49 43" />
      </svg>
      {!compact && (
        <span
          className={`exbabel-loading-wordmark ${inverted ? 'exbabel-wordmark-inverted' : ''}`}
        >
          EXBABEL
        </span>
      )}
      <span className="sr-only">{label}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: inverted ? '#0f172a' : '#f4f7fe',
        }}
      >
        {content}
      </div>
    );
  }

  return content;
}

export function EventCardsSkeleton() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '64px 0', width: '100%' }}>
      <ExbabelLoading label="Loading events" />
    </div>
  );
}

export function EventDetailSkeleton() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f4f7fe',
        width: '100%',
      }}
    >
      <ExbabelLoading label="Loading event" />
    </div>
  );
}
